/* __next_internal_client_entry_do_not_use__ Default,keyContactsTailwindVariants auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import ImageWrapper from 'helpers/SitecoreWrappers/ImageWrapper/ImageWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getCtaStyle } from 'lib/utils/cta-utils';
import { getTestProps } from 'lib/testing/utils';
import { RemixIcon } from 'helpers/RemixIcon';
import { expertCardTailwindVariants } from '../lists/ExpertCard';
import { tv } from 'tailwind-variants';
import useDictionary from 'lib/hooks/useDictionary';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const KeyContacts = (props)=>{
    const isEditing = useIsEditing();
    const { sitecoreContext } = useSitecoreContext();
    const { getDictionaryValue } = useDictionary();
    // If no personData in fields, try to read from route fields
    let person = props?.fields?.personData;
    if (!person) {
        const routeFields = sitecoreContext?.route?.fields;
        // Try keyContact first, then secondaryKeyContact
        person = routeFields?.keyContact || routeFields?.secondaryKeyContact;
    }
    const { RenderingIdentifier } = props?.params || {};
    if (!person) {
        return /*#__PURE__*/ _jsx("div", {
            ...getTestProps(`key-contact-empty-${RenderingIdentifier}`),
            children: /*#__PURE__*/ _jsx("p", {
                children: "No key contact data available."
            })
        });
    }
    const { container, imageSection, imageWrapper, contentSection, contentTop, contentBottom, details, nameTV, roleTV, linkedInWrapper, linkedInIcon, separator, ctaWrapper, ctaLink } = keyContactsTailwindVariants();
    const styles = parseStyleParams(props.params, [
        'cta1'
    ]);
    const name = person?.fields?.firstname?.value && person?.fields?.lastname?.value ? {
        value: `${person.fields.firstname.value} ${person.fields.lastname.value}`
    } : undefined;
    const role = person?.fields?.jobtitle;
    const linkedInLink = person?.fields?.linkedInURL?.value ? {
        value: {
            href: person.fields.linkedInURL.value,
            target: '_blank'
        }
    } : undefined;
    const getExpertProfileUrl = (currentUrl)=>{
        // Remove single letter slug pattern: /our-people/[a-z]/[slug] -> /our-people/[slug]
        if (currentUrl.includes('/our-people/')) {
            // Match pattern: /our-people/[single-letter-a-z]/[rest-of-path]
            const pattern = /\/our-people\/([a-z])\/(.+)/;
            const match = currentUrl.match(pattern);
            if (match) {
                // Return /our-people/[rest-of-path]
                return `/our-people/${match[2]}`;
            }
        }
        return currentUrl;
    };
    const profileLink = person?.url ? {
        value: {
            href: getExpertProfileUrl(person.url),
            text: getDictionaryValue('ExpertCardCtaText') || 'Find out more'
        }
    } : undefined;
    return /*#__PURE__*/ _jsxs("article", {
        className: container(),
        "data-component": "authorable/shared/content/keycontacts",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`key-contact-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: imageSection(),
                children: person?.fields?.picture?.value?.src ? /*#__PURE__*/ _jsx(ImageWrapper, {
                    field: person.fields.picture,
                    className: imageWrapper(),
                    ...getTestProps(`kc-image`)
                }) : /*#__PURE__*/ _jsx(ImageWrapper, {
                    field: {
                        value: {
                            src: '/assets/profile_placeholder.png',
                            alt: 'No image'
                        }
                    },
                    className: imageWrapper(),
                    ...getTestProps(`related-profile-image-placeholder`)
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: contentSection(),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: contentTop(),
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: details(),
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                            className: nameTV(),
                                            field: name,
                                            tag: "div",
                                            ...getTestProps(`kc-name`)
                                        }),
                                        /*#__PURE__*/ _jsx(PlainTextWrapper, {
                                            className: roleTV(),
                                            field: role,
                                            tag: "div",
                                            ...getTestProps(`kc-role`)
                                        })
                                    ]
                                }),
                                linkedInLink?.value?.href && /*#__PURE__*/ _jsx(LinkWrapper, {
                                    ctaComponentClass: "component-card-item-button-1-color",
                                    field: linkedInLink,
                                    className: linkedInWrapper(),
                                    editable: false,
                                    "aria-label": `View ${name?.value || 'contact'} LinkedIn profile`,
                                    suppressNewTabIcon: true,
                                    ...getTestProps(`kc-linkedin`),
                                    children: /*#__PURE__*/ _jsx(RemixIcon, {
                                        name: "linkedin-box-fill",
                                        size: "xl",
                                        className: linkedInIcon()
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: contentBottom(),
                        children: [
                            profileLink?.value?.href && /*#__PURE__*/ _jsx("div", {
                                className: separator()
                            }),
                            profileLink?.value?.href && /*#__PURE__*/ _jsx("div", {
                                className: ctaWrapper(),
                                children: /*#__PURE__*/ _jsx(LinkWrapper, {
                                    ctaComponentClass: "component-card-item-button-1-color",
                                    className: ctaLink(),
                                    field: profileLink,
                                    ctaIcon: "arrow-right",
                                    ctaIconSize: "s",
                                    ctaStyle: getCtaStyle(styles.cta1, 'tertiary'),
                                    ...getTestProps(`kc-cta`)
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export const Default = withStandardComponentWrapper(KeyContacts, false);
export const keyContactsTailwindVariants = tv({
    extend: expertCardTailwindVariants,
    slots: {
        container: [
            'flex',
            'flex-col',
            'md:!flex-col',
            'lg:!flex-col',
            'w-full',
            'h-full',
            'overflow-hidden',
            'rounded-general-border-radius-card',
            'shadow-color-black-alpha-10',
            'shadow-[0_0_8px_0]'
        ],
        imageSection: [
            'relative',
            'w-full',
            'md:!w-full',
            'lg:!w-full',
            'overflow-hidden',
            'aspect-[4/3]',
            'md:!aspect-[4/3]',
            'lg:!aspect-[4/3]',
            'rounded-t-general-border-radius-card',
            'md:!rounded-t-general-border-radius-card',
            'md:!rounded-b-none',
            'lg:!rounded-b-none',
            'lg:!rounded-t-general-border-radius-card'
        ],
        imageWrapper: [
            'aspect-[4/3]'
        ],
        contentSection: [
            'flex',
            'flex-col',
            'flex-1',
            'w-full',
            'md:!w-full',
            'lg:!w-full',
            'gap-spacing-spacing-24',
            'py-component-card-item-landscape-content-1-col-padding-y',
            'px-component-card-item-landscape-content-1-col-padding-x',
            'bg-component-featureCard-surface',
            'rounded-b-general-border-radius-card',
            'md:!rounded-b-general-border-radius-card',
            'md:!rounded-t-none',
            'lg:!rounded-t-none',
            'lg:!rounded-b-general-border-radius-card'
        ],
        details: [
            'flex',
            'items-start',
            'justify-between',
            'gap-spacing-spacing-16'
        ],
        linkedInWrapper: [
            'flex',
            'w-10',
            'h-10',
            '!p-0',
            'text-white',
            'items-center',
            'justify-center',
            'hover:opacity-80',
            'transition-opacity',
            'duration-200',
            '[&:hover_svg]:!text-white'
        ],
        nameTV: [
            'text-white',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-semibold',
            'leading-normal',
            'text-left'
        ],
        roleTV: [
            'text-white',
            'font-typography-font-family-body',
            'text-typography-font-size-body-medium',
            'font-normal',
            'leading-normal',
            'mt-spacing-spacing-4',
            'text-left'
        ]
    }
});
